import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule, ExtraOptions } from '@angular/router';
import { environment } from '../environments/environment';
import { RegistrationPageComponent } from './components/pubs/registration-page/registration-page.component';
import { PayComponent } from './components/pay/pay.component';
import { TermsComponent } from './components/terms/terms/terms.component';
import { ReviewsComponent } from './components/review/review.component';
import { PartnersComponent } from './components/partners/partners.component';
import { CreateOrUpdateComponent } from './components/products/create-or-update/create-or-update.component';
import { ViewOrEditComponent } from './components/products/view-or-edit/view-or-edit.component';
import { WhatsappVerificationComponent } from './components/whatsapp-verification/whatsapp-verification.component';
import { PaypalPlanListComponent } from './components/paypal/plan-list/plan-list.component';
import { LoginComponent } from './components/login/login.component';
import { CreatePlanComponent } from './components/paypal/create-plan/create-plan.component';
import { ViewListingComponent } from './components/products/view-listing/view-listing.component';
import { AuthGuard } from './auth.guard';
import { FinishLoginComponent } from './components/login/finish-login/finish-login.component';
import { LandingPageComponent } from './components/products/landing-page/landing-page.component';
import { PubsLandingPageComponent } from './components/pubs/landing-page/landing-page.component';
import { PubViewOrEditComponent } from './components/pubs/view-or-edit/view-or-edit.component';
import { PubCreateOrUpdateComponent } from './components/pubs/create-or-update/pub-create-or-update.component';
import { ViewPubsComponent } from './components/pubs/view-pubs/view-pubs.component';
import { adminGuard } from './guards/admin.guard';
import { NavbarComponent } from './components/navbar/navbar.component';
import { CategoryWiseProductsComponent } from './components/products/category-wise-products/category-wise-products.component';
export const routerOptions: ExtraOptions = {
  //scrollOffset: [0, 64],  // scroll offset when scrolling to an element (optional)
  scrollPositionRestoration: 'enabled',
  anchorScrolling: 'enabled',
  enableTracing: environment.production ? false : true
}

export const routes: Routes = [
  // { path: '', component: NavbarComponent},
  { path: 'login', component: LoginComponent },
  { path: 'register', component: RegistrationPageComponent },
  { path: 'otp', component: WhatsappVerificationComponent },
  { path: 'terms', component: TermsComponent },
  { path: 'review', component: ReviewsComponent },
  { path: 'pay', component: PayComponent },
  { path: 'partners', component: PartnersComponent, canActivate: [adminGuard] },
  { path: 'paypal-plan', component: CreatePlanComponent, canActivate: [AuthGuard, adminGuard] },
  { path: 'plan-list', component: PaypalPlanListComponent, canActivate: [AuthGuard, adminGuard] },
  //listings
  // { path: '', component: LandingPageComponent }, //listing landing page
  { path: 'listing', component: CreateOrUpdateComponent, canActivate: [AuthGuard] },
  { path: 'listing/:id', component: CreateOrUpdateComponent, canActivate: [AuthGuard] },
  { path: 'listings', component: ViewOrEditComponent, canActivate: [AuthGuard] },
  { path: 'view/:id', component: ViewListingComponent },
  { path: 'category/:category', component: CategoryWiseProductsComponent },
  //pubs
  { path: 'pubs', component: PubsLandingPageComponent },
  { path: 'pubs/manage', component: PubViewOrEditComponent, canActivate: [AuthGuard] },
  { path: 'pub', component: PubCreateOrUpdateComponent, canActivate: [AuthGuard] },
  { path: 'pubs/:id', component: PubCreateOrUpdateComponent, canActivate: [AuthGuard] },
  { path: 'pubs/view/:id', component: ViewPubsComponent },

];

@NgModule({
  imports: [CommonModule, RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule]
})
export class AppRoutingModule { }

